import { Injectable } from '@angular/core';
import { NotificationService } from 'app/notifications/notification.service';
import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { BackendService } from '../core/backend.service';
import { CONFIG } from '../core/config';
import { HbNotification } from '../notifications/notification';
import { NotificationState } from '../notifications/notification-state';
import { Event } from '../viewmodels/events/event';
import { EventParameters } from './event-parameters';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  public eventsChanged = new Subject();

  constructor(private backendService: BackendService, private notificationService: NotificationService) {}

  private triggerEventsChanged = () => this.eventsChanged.next();

  public createEvent(event: Event): Observable<Event> {
    return this.backendService.create<Event>(Event, event).pipe(finalize(this.triggerEventsChanged));
  }

  public updateEvent(event: Event): Observable<Event> {
    return this.backendService.update<Event>(Event, event.eventId, event).pipe(finalize(this.triggerEventsChanged));
  }

  public getUserEventCount(parameters: EventParameters): Observable<number> {
    return this.backendService.postObjectRoute(CONFIG.apiRoutes.eventsCount, parameters, false);
  }

  public getEvent(eventId: string): Observable<Event> {
    return this.backendService.getById<Event>(Event, eventId);
  }

  public deleteEvent(eventId: string): Observable<Event> {
    return this.backendService.delete<Event>(Event, eventId).pipe(finalize(this.triggerEventsChanged));
  }

  public showSaveNotification(state: NotificationState) {
    this.showNotification('Event Saved', state);
  }

  public showNotification(description: string, state: NotificationState) {
    const notification = new HbNotification();
    notification.description = description;
    notification.state = state;
    this.notificationService.displayToast(notification);
  }
}
